
import { supabase } from '../client';
import { Product } from './types';

export const getProducts = async (shopId?: string, organizationId?: string): Promise<Product[]> => {
  try {
    console.log("Calling getProducts with shopId:", shopId, "organizationId:", organizationId);
    
    // Si aucun des filtres n'est fourni, retourner un tableau vide immédiatement
    if (!shopId && !organizationId) {
      console.log("No filters provided, returning empty array immediately");
      return [];
    }
    
    // Construire la requête avec tous les filtres dès le début
    let query = supabase
      .from('products')
      .select('*');
    
    // Appliquer les filtres immédiatement
    if (organizationId) {
      console.log("Filtering products by organization_id:", organizationId);
      query = query.eq('organization_id', organizationId);
    }
    
    if (shopId) {
      console.log("Filtering products by shop_id:", shopId);
      query = query.eq('shop_id', shopId);
    }
    
    // Appliquer le tri à la fin
    query = query.order('created_at', { ascending: false });
    
    // Exécuter la requête
    const { data, error } = await query;
    
    if (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
    
    // Log le résultat
    console.log(`Products fetched: ${data?.length || 0} products for ${shopId ? 'shop ' + shopId : ''} ${organizationId ? 'organization ' + organizationId : ''}`);
    
    return data || [];
  } catch (error) {
    console.error('Failed to fetch products:', error);
    throw error;
  }
};

export const getProductById = async (id: string): Promise<Product | null> => {
  try {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
    
    console.log("Product fetched:", data);
    return data;
  } catch (error) {
    console.error(`Failed to fetch product with id ${id}:`, error);
    throw error;
  }
};
